export default __webpack_public_path__ + "static/10-1c437d9c2b8a4a59d41aa9011c9cc3bc.jpg";